import React from "react";

export default function No_Page() {
    return (
        <div>
            No Page
        </div>
    )
}